<style scoped>
	.province-list{
	    background: #fff;
		display: flex;
		height: 45px;
		line-height: 45px;
		padding-left: 15px;
		margin-bottom: 4px;
	}
	.province-list select{
		display: flex;
		flex: 1;
		margin-left: 15px;
	}
	.title-wrapper{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 10;
		background: #f5f5f5;
	}
	.list-wrapper{
		margin-top: 111px;
	}
</style>
<template>
  <div class="quality-recommend">
	<div class="title-wrapper">
		  <div class="title acea-row row-center-wrapper">
		    <div class="line"></div>
		    <div class="name">
		      <span class="iconfont" :class="icon"></span>{{ name }}
		    </div>
		    <div class="line"></div>
		  </div>
		  <div class="province-list">
		  	<label for="">选择省份</label>
		  	<select name="" id="" v-model="province" @change="provinceChange">
		  		<option value="">全部</option>
		  		<option  v-for="(key, value) in provinceList" :key="value" :value="key">{{key}}</option>
		  	</select>
		  </div>
	 </div>
	<div class="list-wrapper">
		<GoodList :good-list="goodsList" :is-sort="false"></GoodList>
	</div>
    
  </div>
</template>
<script>
import GoodList from "@components/GoodList";
import { getGroomList } from "@api/store";
import provinceJson from '../../assets/js/city'
export default {
  name: "HotNewGoods",
  components: {
    GoodList
  },
  props: {},
  data: function() {
    return {
      imgUrls: [],
      goodsList: [],
      name: "",
      icon: "",
	  province:"",
	  provinceList:[]
    };
  },
  mounted: function() {
    this.titleInfo();
    this.getIndexGroomList();
	// this.provinceList = provinceJson.province_list
	this.provinceList = provinceJson.map(item=>item.label)
  },
  methods: {
    titleInfo: function() {
      let type = this.$route.params.type;
      if (type === "1") {
        this.name = "精品推荐";
        this.icon = "icon-jingpintuijian";
        document.title = "精品推荐";
      } else if (type === "2") {
        this.name = "店铺街";
        this.icon = "icon-remen";
        document.title = "热门榜单";
      } else if (type === "3") {
        this.name = "首发新品";
        this.icon = "icon-xinpin";
        document.title = "首发新品";
      }
    },
	provinceChange(){
		console.log(this.province)
		this.getIndexGroomList()
	},
    getIndexGroomList: function() {
      let that = this;
      let type = this.$route.params.type;
	  let keyword = this.province
      console.log(type);
      getGroomList(type,keyword)
        .then(res => {
          that.imgUrls = res.data.banner;
		  let list = res.data.list || []
          that.goodsList = list;
          console.log(res.data.list);
		  if(list.length==0){
			   that.$dialog.toast({ mes: '暂无数据' });
		  }
        })
        .catch(function(res) {
          that.$dialog.toast({ mes: res.msg });
        });
    }
  }
};
</script>
